import React from 'react';
import { Col, Form, Input, Row, Select } from "antd";
import { userRols } from "../../../helpers/userRols";
import { LANGUAGE_LABELS } from "helpers/adminLabels";

const ProfessionalPersonalData = ({ languages, professionalRole, clinics = [], form }) => {
  console.log('ProfessionalPersonalData - clinics:', clinics);
  console.log('ProfessionalPersonalData - clinics length:', clinics.length);
  const OPTIONS = ['english',
    'bulgarian',
    'german',
    'greek',
    'russian',
    'spanish',
    'italian',
    'french']

  return (
    <Row gutter={24}>
      {professionalRole !== userRols.clinic && <Col xs={24} md={12}>
        <Form.Item
          name="name"
          label="Име"
          rules={[{ required: true, message: 'Моля, въведи име!' }]}
        >
          <Input placeholder="Име" />
        </Form.Item>
      </Col>}
      {professionalRole !== userRols.clinic && <Col xs={24} md={12}>
        <Form.Item
          name="surname"
          label="Фамилия"
          rules={[{ required: true, message: 'Моля, въведи фамилия!' }]}
        >
          <Input placeholder="Фамилия" />
        </Form.Item>
      </Col>}
      {professionalRole !== userRols.clinic && <Col xs={24} md={12}>
        <Form.Item
          name="telephone"
          label="Телефон"
          rules={[{ required: true, message: 'Моля, въведи телефон!' }]}
        >
          <Input placeholder="Телефон" />
        </Form.Item>
      </Col>}
      {professionalRole !== userRols.clinic && <Col xs={24} md={12}>
        <Form.Item
          name="email"
          label="Имейл"
          rules={[{ required: true, message: 'Моля, въведи имейл!', type: 'email' }]}
        >
          <Input placeholder="Имейл" />
        </Form.Item>
      </Col>}
      {![userRols.shelter].includes(professionalRole) && <Col xs={24} md={24}>
        <Form.Item
          name={professionalRole === userRols.clinic ? ["metadata", "companyDescription"] : ["metadata", "bio"]}
          label={[userRols.hotel, userRols.clinic].includes(professionalRole) ? 'Описание на фирмата' : "Биография"}
        >
          <Input.TextArea
            placeholder={[userRols.hotel, userRols.clinic].includes(professionalRole) ? 'Описание на фирмата' : "Биография"}
            rows={8} />
        </Form.Item>
      </Col>}
      <Col xs={24} md={12}>
        <Form.Item
          name="languages"
          label="Езици"
          initialValue={languages}
        >
          <Select
            mode="multiple"
            placeholder="Езици"
            options={OPTIONS.map(option => ({
              value: option,
              label: LANGUAGE_LABELS[option] ?? option
            }))}
          ></Select>
        </Form.Item>
      </Col>
      {/* Show clinic selection for non-clinic professionals */}
      {professionalRole !== userRols.clinic && <Col xs={24} md={12}>
        <Form.Item
          name={["metadata", "associatedClinic"]}
          label="Свързана клиника"
        >
          <Select
            placeholder="Избери клиника"
            allowClear
            showSearch
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
            options={[
              {
                value: null,
                label: "Няма клиника",
              },
              ...clinics.map(clinic => {
                const option = {
                  value: clinic._id,
                  label: clinic.metadata?.businessName || `${clinic.name} ${clinic.surname}`,
                };
                console.log('Clinic option:', option);
                return option;
              })
            ]}
          />
        </Form.Item>
      </Col>}
    </Row>
  );
};

export default ProfessionalPersonalData;
